import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import useMapLayers from '#/map/hooks/useMapLayers';
import MapLayerControls from '#/map/components/MapLayerControls';
import {
  ThemeContext,
  SetThemeContext,
} from '#/shared/providers/ThemeContainer';
import otpUiConfig from '#/otp-ui-config';

function MapLayerControlsContainer() {
  const currentTheme = useContext(ThemeContext);
  const setTheme = useContext(SetThemeContext);

  const {
    companies,
    routeLayers,
    realtimeVehiclesToggled,
    setBaseLayerStreets,
    setBaseLayerAerials,
    setBaseLayerRoutes,
    setBaseLayerRoutesAerials,
    setBaseLayerRoutesThreeDimensional,
    setBaseLayerThreeDimensional,
    toggleRentalCompany,
    toggleParkAndRide,
    toggleRealtimeVehicles,
    toggleRouteLayers,
    toggleAlwaysShowMapControls,
  } = useMapLayers();
  const {
    baseLayer: currentBaseLayer,
    modes,
    alwaysShowMapControls,
  } = useSelector(s => s.map);
  const { companies: configCompanies } = otpUiConfig;

  return (
    <MapLayerControls
      configCompanies={configCompanies}
      currentTheme={currentTheme.name}
      currentBaseLayer={currentBaseLayer}
      modes={modes}
      selectedCompanies={companies}
      realtimeVehiclesToggled={realtimeVehiclesToggled}
      routeLayers={routeLayers}
      alwaysShowMapControls={alwaysShowMapControls}
      setTheme={setTheme}
      setBaseLayerStreets={setBaseLayerStreets}
      setBaseLayerAerials={setBaseLayerAerials}
      setBaseLayerRoutes={setBaseLayerRoutes}
      setBaseLayerRoutesAerials={setBaseLayerRoutesAerials}
      setBaseLayerRoutesThreeDimensional={setBaseLayerRoutesThreeDimensional}
      setBaseLayerThreeDimensional={setBaseLayerThreeDimensional}
      toggleRentalCompany={toggleRentalCompany}
      toggleParkAndRide={toggleParkAndRide}
      toggleRealtimeVehicles={toggleRealtimeVehicles}
      toggleRouteLayers={toggleRouteLayers}
      toggleAlwaysShowMapControls={toggleAlwaysShowMapControls}
    />
  );
}

export default MapLayerControlsContainer;
